const INBOXTYPE = {
  UNASSIGNED: 'unassigned',
  ALL: 'all',
  PRIVATE: 'private',
  ALL_PRIVATE: 'all_private',
  DONE: 'done',
  SPAM: 'spam',
  BOT: 'bot',
  UNFOLLOW: 'unfollow',
};

export default INBOXTYPE;
